import { IUserDashboardSettingsRequest } from "../views-interfaces/dashboard-model.interface";
import type { IFirmUserCompleteName } from "@interfaces/ifirm-users.interface";
import type { IUserDashboardSettingsMapByDashboard } from "@interfaces/user-dashboard-settings.interface";

export interface IUserModelRoles {
    active: boolean;
    translateStatus: string;
    status: null | string;
}

export interface IUserModelFirmAccess {
    firmId: string;
    dashboard: string;
    rights: string;
    restricted: boolean;
    confidential: boolean;
}

export interface IUserModel {
    Active: boolean;
    userId: string;
    IFirmUserId: string;
    firstName: string;
    lastName: string;
    email: string;
    whenOpeningAFile: boolean;
    whenClosingAFile: boolean;
    firmsAccess: IUserModelFirmAccess[];
    IsAdmin: boolean;
    IsSupport: boolean;
    CommunicationLanguage: string;
}

export interface ListuserModel {
    Id: string;
    IsActive: string;
    FirstName: string;
    LastName: string;
    Email: string;
    FirmId: string;
}

export class SettingsUserModel implements IUserModel {
    Active = true;
    userId = "";
    IFirmUserId: "";
    firstName = "";
    lastName = "";
    email = "";
    CommunicationLanguage = "";
    whenOpeningAFile = false;
    whenClosingAFile = false;
    IsAdmin: boolean;
    IsSupport: boolean;
    firmsAccess = [];
}

export interface INewUserRequestDataModel {
    FirstName: string;
    LastName: string;
    Email: string;
    IsAdmin: boolean;
    IsSupport: boolean;
    isOnlineSince?: number;
}
export class NewUserRequestDataModel implements INewUserRequestDataModel {
    FirstName = "";
    LastName = "";
    Email = "";
    IFirmUserId = "";
    IsAdmin = false;
    IsSupport = false;
    CommunicationLanguage = "";
    LastDashboardId = "";
}

export class UserDataModel implements INewUserRequestDataModel {
    Id = "";
    IFirmUserId = "";
    FirstName = "";
    LastName = "";
    Email = "";
    Active = true;
    IsAdmin = false;
    IsSupport = false;
    CommunicationLanguage = "";
    LastDashboardId?: string;
    OfficeId?: string | null;
    IsOnlineSince?: number;
    GroupFilteringId1?: number;
    GroupFilteringId2?: number;
    UserCulture?: string;
    LicenseEnabled?: boolean;
    completeName?: IFirmUserCompleteName;
    FullName?: string;
    ReverseFullName?: string;
    restrictedIFirmUserId?: string;
    UserDashboardSettings?: IUserDashboardSettingsMapByDashboard;
}

export interface IUsersListResponse {
    Code: number;
    Users: UserDataModel[];
}

export interface IUserResponse {
    Code: number;
    User: UserDataModel;
}

export interface IUserDeleteResponse {
    Code: number;
    Message?: string;
}

export interface IUserUpdateData {
    FirstName?: string;
    LastName?: string;
    Email?: string;
    Active?: boolean;
    IsAdmin?: boolean;
    IsSupport?: boolean;
    CommunicationLanguage?: string;
    IFirmUserId?: string;
    LastDashboardId?: string;
    OfficeId?: string | null;
    IsOnlineSince?: number;
}

export interface IUserChangeEvent {
    userId: string;
    userData?: UserDataModel;
}

export class UsersFilterModel {
    FirstName?: string;
    LastName?: string;
    Email?: string;
}
